'use strict';

var BookingListCtrl = function(
  $scope,
  $rootScope,
  $state,
  $stateParams,
  io,
  bookings,
  BookingDA,
  gettextCatalog,
  uiGridConstants,
  ModalService,
) {
  var self = this;
  this._state = $state;
  this._stateParams = $stateParams;
  this._ModalService = ModalService;

  this.bookings = bookings;

  this.setProcessed = function(notProcessedBookingIds) {
    var officeId = _.get(self, 'bookings[0].officeId', '');

    return BookingDA.setProcessed({
      officeId: officeId,
      ids: notProcessedBookingIds,
    }).then(function() {
      self.bookings.forEach(function(booking) {
        booking.processed = true;
      });

      $rootScope.$broadcast('setBookingsProcessed');
    });
  };

  this.getPaymentMethod = function(booking) {
    var paymentMethod = _.get(booking, 'payment.method');

    switch (paymentMethod) {
      case 'credit_card':
        return gettextCatalog.getString('PAYMENT_METHOD_CREDIT_CARD');
      case 'local':
        return gettextCatalog.getString('PAYMENT_METHOD_USER_LOCAL');
      case 'invoice':
        return gettextCatalog.getString('PAYMENT_METHOD_INVOICE');
      case 'empty':
        return gettextCatalog.getString('PAYMENT_METHOD_USER_EMPTY');
      default:
        return '';
    }
  };

  /**
   * add new booking, if socket emit new booking
   */
  $scope.$on('Booking:save', function(event, newBooking) {
    self.bookings.push(newBooking);
  });

  $scope.$on('$destroy', function() {
    var notProcessedBookingIds = bookings
      .filter(function(booking) {
        return !booking.processed;
      })
      .map(function(booking) {
        return booking._id;
      });

    if (notProcessedBookingIds.length) {
      self.setProcessed(notProcessedBookingIds);
    }
  });
};

BookingListCtrl.prototype.openRelatedAppointment = function(booking) {
  if (
    _.get(booking, 'declined') ||
    !_.get(booking, 'appointments[0]') ||
    _.get(booking, 'appointments[0].cancelled')
  ) {
    return;
  }

  var openAppointment = _.get(booking, 'appointments[0]');

  if (!openAppointment) return;

  var appointmentDate = moment(openAppointment.start).format('YYYY-MM-DD');
  if (this._stateParams.date !== appointmentDate) {
    this._state.go('private.main.calendar', {
      date: appointmentDate,
    });
  }

  this._ModalService.openAppointmentModal(openAppointment);
};

BookingListCtrl.prototype.getStartDate = function(booking) {
  var appointmentStartDate = _.get(booking, 'appointments[0].start');
  var bookingStartDate = _.get(booking, 'start');

  return appointmentStartDate || bookingStartDate;
};

module.exports = BookingListCtrl;



// WEBPACK FOOTER //
// ./src/app/modules/booking/BookingListCtrl.js